// Mock data for AIConneqtors Clone

export const companyLogos = [
  { name: 'Capgemini', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/92/Capgemini_logo_2017.svg/320px-Capgemini_logo_2017.svg.png' },
  { name: 'Exotel', logo: 'https://yt3.googleusercontent.com/ytc/AIdro_mU0iMAP3XvyE3r-x5P2kLknwYZIKoQOBz9fJMB=s900-c-k-c0x00ffffff-no-rj' },
  { name: 'NVIDIA', logo: 'https://upload.wikimedia.org/wikipedia/sco/thumb/2/21/Nvidia_logo.svg/1200px-Nvidia_logo.svg.png' },
  { name: 'MG Motors', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/2/28/MG_Motor_Logo.svg/1200px-MG_Motor_Logo.svg.png' },
  { name: 'Cipla', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/77/Cipla_logo.svg/1200px-Cipla_logo.svg.png' }
];

export const useCases = [
  'Lead Generation',
  'Appointments',
  'Support',
  'Negotiation',
  'Collections'
];

export const supportedLanguages = [
  { code: 'en', name: 'English', native: 'English', flag: '🇺🇸' },
  { code: 'es', name: 'Spanish', native: 'Español', flag: '🇪🇸' },
  { code: 'fr', name: 'French', native: 'Français', flag: '🇫🇷' },
  { code: 'de', name: 'German', native: 'Deutsch', flag: '🇩🇪' },
  { code: 'it', name: 'Italian', native: 'Italiano', flag: '🇮🇹' },
  { code: 'pt', name: 'Portuguese', native: 'Português', flag: '🇵🇹' },
  { code: 'nl', name: 'Dutch', native: 'Nederlands', flag: '🇳🇱' },
  { code: 'pl', name: 'Polish', native: 'Polski', flag: '🇵🇱' },
  { code: 'ru', name: 'Russian', native: 'Русский', flag: '🇷🇺' },
  { code: 'uk', name: 'Ukrainian', native: 'Українська', flag: '🇺🇦' },
  { code: 'tr', name: 'Turkish', native: 'Türkçe', flag: '🇹🇷' },
  { code: 'ar', name: 'Arabic', native: 'العربية', flag: '🇸🇦' },
  { code: 'he', name: 'Hebrew', native: 'עברית', flag: '🇮🇱' },
  { code: 'hi', name: 'Hindi', native: 'हिंदी', flag: '🇮🇳' },
  { code: 'bn', name: 'Bengali', native: 'বাংলা', flag: '🇧🇩' },
  { code: 'ta', name: 'Tamil', native: 'தமிழ்', flag: '🇮🇳' },
  { code: 'te', name: 'Telugu', native: 'తెలుగు', flag: '🇮🇳' },
  { code: 'mr', name: 'Marathi', native: 'मराठी', flag: '🇮🇳' },
  { code: 'gu', name: 'Gujarati', native: 'ગુજરાતી', flag: '🇮🇳' },
  { code: 'kn', name: 'Kannada', native: 'ಕನ್ನಡ', flag: '🇮🇳' },
  { code: 'ml', name: 'Malayalam', native: 'മലയാളം', flag: '🇮🇳' },
  { code: 'pa', name: 'Punjabi', native: 'ਪੰਜਾਬੀ', flag: '🇮🇳' },
  { code: 'ur', name: 'Urdu', native: 'اردو', flag: '🇵🇰' },
  { code: 'zh', name: 'Chinese (Mandarin)', native: '中文', flag: '🇨🇳' },
  { code: 'zh-tw', name: 'Chinese (Traditional)', native: '繁體中文', flag: '🇹🇼' },
  { code: 'ja', name: 'Japanese', native: '日本語', flag: '🇯🇵' },
  { code: 'ko', name: 'Korean', native: '한국어', flag: '🇰🇷' },
  { code: 'th', name: 'Thai', native: 'ไทย', flag: '🇹🇭' },
  { code: 'vi', name: 'Vietnamese', native: 'Tiếng Việt', flag: '🇻🇳' },
  { code: 'id', name: 'Indonesian', native: 'Bahasa Indonesia', flag: '🇮🇩' },
  { code: 'ms', name: 'Malay', native: 'Bahasa Melayu', flag: '🇲🇾' },
  { code: 'tl', name: 'Filipino', native: 'Tagalog', flag: '🇵🇭' },
  { code: 'sv', name: 'Swedish', native: 'Svenska', flag: '🇸🇪' },
  { code: 'no', name: 'Norwegian', native: 'Norsk', flag: '🇳🇴' },
  { code: 'da', name: 'Danish', native: 'Dansk', flag: '🇩🇰' },
  { code: 'fi', name: 'Finnish', native: 'Suomi', flag: '🇫🇮' },
  { code: 'el', name: 'Greek', native: 'Ελληνικά', flag: '🇬🇷' },
  { code: 'cs', name: 'Czech', native: 'Čeština', flag: '🇨🇿' },
  { code: 'sk', name: 'Slovak', native: 'Slovenčina', flag: '🇸🇰' },
  { code: 'hu', name: 'Hungarian', native: 'Magyar', flag: '🇭🇺' },
  { code: 'ro', name: 'Romanian', native: 'Română', flag: '🇷🇴' },
  { code: 'bg', name: 'Bulgarian', native: 'Български', flag: '🇧🇬' },
  { code: 'hr', name: 'Croatian', native: 'Hrvatski', flag: '🇭🇷' },
  { code: 'sr', name: 'Serbian', native: 'Српски', flag: '🇷🇸' },
  { code: 'sl', name: 'Slovenian', native: 'Slovenščina', flag: '🇸🇮' },
  { code: 'et', name: 'Estonian', native: 'Eesti', flag: '🇪🇪' },
  { code: 'lv', name: 'Latvian', native: 'Latviešu', flag: '🇱🇻' },
  { code: 'lt', name: 'Lithuanian', native: 'Lietuvių', flag: '🇱🇹' },
  { code: 'sw', name: 'Swahili', native: 'Kiswahili', flag: '🇰🇪' },
  { code: 'af', name: 'Afrikaans', native: 'Afrikaans', flag: '🇿🇦' },
  { code: 'ca', name: 'Catalan', native: 'Català', flag: '🇪🇸' },
  { code: 'eu', name: 'Basque', native: 'Euskara', flag: '🇪🇸' },
  { code: 'gl', name: 'Galician', native: 'Galego', flag: '🇪🇸' },
];

export const coreCapabilities = [
  {
    icon: 'Languages',
    title: 'Multi-Language',
    description: 'Serve users in 50+ languages worldwide'
  },
  {
    icon: 'ArrowUpRight',
    title: 'Scale Outbound',
    description: 'Automate lead gen, reminders & collections'
  },
  {
    icon: 'Clock',
    title: '24/7 Inbound',
    description: 'Handle bookings and inquiries around the clock'
  },
  {
    icon: 'Plug',
    title: 'Connect Stack',
    description: 'Integrate with CRM, Sheets, Slack, n8n'
  },
  {
    icon: 'GraduationCap',
    title: 'Quick Training',
    description: 'Train AI with your own call recordings'
  },
  {
    icon: 'Phone',
    title: 'Phone Numbers',
    description: 'Buy US (+1) numbers instantly'
  }
];

export const howItWorksSteps = [
  {
    step: 1,
    icon: 'PenLine',
    title: 'Write',
    description: 'Describe what type of Voice AI assistant you want'
  },
  {
    step: 2,
    icon: 'FlaskConical',
    title: 'Test',
    description: 'Try out your assistant and see how it performs'
  },
  {
    step: 3,
    icon: 'Puzzle',
    title: 'Add Functionalities',
    description: 'Enhance through chat and drag-and-drop'
  },
  {
    step: 4,
    icon: 'Rocket',
    title: 'Deploy',
    description: 'Make your assistant available to your users'
  },
  {
    step: 5,
    icon: 'LineChart',
    title: 'Observe & Monitor',
    description: 'Track performance and make improvements'
  }
];

export const stepDetails = {
  1: {
    title: 'Create Voice AI Assistants with Natural Language',
    subtitle: 'Simply describe what you want your Voice AI assistant to do, and we\'ll build it for you.',
    features: [
      {
        icon: 'MessageCircle',
        title: 'Conversational Creation',
        description: 'Build your assistant through natural conversation - just chat with our platform about what you need.'
      },
      {
        icon: 'MousePointerSquare',
        title: 'Drag-and-Drop Interface',
        description: 'Fine-tune your assistant\'s capabilities with our intuitive drag-and-drop editor.'
      },
      {
        icon: 'FileText',
        title: 'Pre-built Templates',
        description: 'Start with industry-specific templates and customize to your needs.'
      }
    ]
  },
  2: {
    title: 'Test Your Voice AI Assistant',
    subtitle: 'Preview and test your assistant in real-time before deployment.',
    features: [
      {
        icon: 'Mic',
        title: 'Live Voice Testing',
        description: 'Test your assistant with actual voice commands and hear responses in real-time.'
      },
      {
        icon: 'MessageSquare',
        title: 'Conversation Simulation',
        description: 'Simulate complete conversations to ensure natural flow and accurate responses.'
      },
      {
        icon: 'ClipboardCheck',
        title: 'Automated Test Suites',
        description: 'Run automated tests to validate assistant behavior across scenarios.'
      }
    ]
  },
  3: {
    title: 'Enhance Your Assistant\'s Capabilities',
    subtitle: 'Add powerful features and integrations through an intuitive interface.',
    features: [
      {
        icon: 'Zap',
        title: 'Action Integrations',
        description: 'Connect to CRMs, calendars, and other tools for seamless automation.'
      },
      {
        icon: 'Database',
        title: 'Knowledge Base',
        description: 'Upload documents and FAQs to train your assistant on your business.'
      },
      {
        icon: 'GitBranch',
        title: 'Custom Workflows',
        description: 'Build complex conversation flows with branching logic.'
      }
    ]
  },
  4: {
    title: 'Deploy Your Assistant Anywhere',
    subtitle: 'Launch your voice AI assistant across multiple channels instantly.',
    features: [
      {
        icon: 'Phone',
        title: 'Phone Integration',
        description: 'Connect to your existing phone system or use our provided numbers.'
      },
      {
        icon: 'Globe',
        title: 'Web Widget',
        description: 'Embed your assistant directly on your website with a simple code snippet.'
      },
      {
        icon: 'Share2',
        title: 'API Access',
        description: 'Integrate with your applications using our comprehensive API.'
      }
    ]
  },
  5: {
    title: 'Monitor and Optimize Performance',
    subtitle: 'Track metrics and continuously improve your assistant.',
    features: [
      {
        icon: 'BarChart2',
        title: 'Real-time Analytics',
        description: 'Monitor call volumes, completion rates, and user satisfaction scores.'
      },
      {
        icon: 'FileSearch',
        title: 'Conversation Insights',
        description: 'Review transcripts and identify areas for improvement.'
      },
      {
        icon: 'TrendingUp',
        title: 'Performance Reports',
        description: 'Generate detailed reports on assistant effectiveness and ROI.'
      }
    ]
  }
};

export const keyFeatures = [
  {
    title: 'Think it. Refine it.',
    description: 'Simply describe your voice AI assistant in plain text, then watch us do the rest. Building voice AI assistants is easier than ever before.',
    image: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Screenshot%202025-04-10%20174945-jmTJsPxKCzcdvehL5M9FkF8gHyBaFL.png'
  },
  {
    title: 'Prompt to configure and edit.',
    description: 'Just write in text what changes you want made to your voice AI assistant. Ask in text to configure 100s of voices, latest LLMs, capabilities like call transfers, adding knowledge bases, making voice AI assistant doing web search.',
    image: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Screenshot%202025-04-10%20175402-IQepytHZrRQ2qmnp4tXlqY62CCGFTr.png'
  },
  {
    title: 'Workflow support',
    description: 'Build reliable voice AI assistants through rigorous simulated testing, real-time observability to track issues, and effortless no-code LLM fine-tuning, evaluation, deployment, and monitoring.',
    image: 'https://hebbkx1anhila5yf.public.blob.vercel-storage.com/Screenshot%202025-04-10%20175059-y1Y4sUywwDHcIKg07MkMOOLy2BcAzY.png'
  }
];

export const testimonials = [
  {
    quote: 'Love the platform!',
    author: 'Lead Designer',
    company: ''
  },
  {
    quote: 'It just works!!',
    author: 'CMO',
    company: 'Pizza Chain'
  },
  {
    quote: "I love this product, it's Bolt for Voice AI.",
    author: 'VP Engineering',
    company: 'Capgemini'
  },
  {
    quote: 'This is the kind of tool that makes Voice AI usable for everyone, not just engineers.',
    author: 'Akhilender Kaukuntla',
    company: 'KAYA AI'
  },
  {
    quote: 'This was different — this was compassion engineered into code. One of the most emotionally intelligent AI platforms I\'ve ever touched.',
    author: 'Jarron Sorrell',
    company: 'Sorrell Holdings LLC'
  }
];

export const faqs = [
  {
    question: 'How quickly can I really create a Voice AI agent?',
    answer: 'You can create a fully functional Voice AI agent on AIConneqtors in under 5 minutes. Just prompt, pick a voice, and launch. No coding required.'
  },
  {
    question: 'Do I need any technical or coding knowledge?',
    answer: 'Not at all. AIConneqtors is built for everyone, from business owners to developers. You can create, test, and deploy AI agents without writing a single line of code.'
  },
  {
    question: 'What kind of Voice AI agents can I build?',
    answer: 'On AIConneqtors, you can build customer support bots, lead generation agents, appointment schedulers, sales assistants, IVR systems, and more. If your business talks to customers, you can automate it here.'
  },
  {
    question: 'Can I customize how the AI agent sounds and responds?',
    answer: "Absolutely. AIConneqtors lets you choose from a variety of natural voices, tones, speaking speeds, and emotional styles. You can also edit the agent's conversation flow and personality to match your brand."
  },
  {
    question: 'What happens after I create my agent?',
    answer: 'Once created on AIConneqtors, you can instantly test your agent, deploy it on calls or your website, and track live analytics on performance and user engagement.'
  },
  {
    question: 'Is there a free trial or demo available?',
    answer: 'Yes. You can sign up for a free trial on AIConneqtors to create your first agent and experience the platform before upgrading to a paid plan.'
  },
  {
    question: 'Can I integrate my AI agent with existing systems?',
    answer: 'Yes. AIConneqtors integrates seamlessly with CRMs, call management tools, APIs, and databases, allowing you to personalize conversations and automate workflows.'
  },
  {
    question: 'How does the AI handle multiple conversations at once?',
    answer: 'AIConneqtors is cloud-based and scalable. Your agents can handle thousands of simultaneous calls or chats without lag or downtime.'
  },
  {
    question: 'Can the AI agent make outbound calls?',
    answer: 'Yes. On AIConneqtors, you can run bulk or targeted outbound call campaigns for sales, follow-ups, or surveys, complete with detailed analytics on performance.'
  },
  {
    question: 'Can I train the AI on my company data?',
    answer: "Yes. You can upload FAQs, documents, or scripts on AIConneqtors, and the AI will learn to respond using your brand's tone and knowledge base."
  }
];

export const navLinks = [
  { label: 'Solutions', href: '#', hasDropdown: true },
  { label: 'Documentation', href: '/docs' },
  { label: 'Pricing', href: '/pricing' },
  { label: 'Contact Us', href: '/contact-us' },
  { label: 'Book an Appointment', href: '/book-appointment' }
];

export const solutionsDropdown = [
  { label: 'Documentation', href: '/docs' },
  { label: 'Pricing', href: '/pricing' },
  { label: 'Contact Us', href: '/contact-us' },
  { label: 'Book an Appointment', href: '/book-appointment' },
  { label: 'Integrations', href: '/integrations' },
  { label: 'Releases', href: '/releases' }
];
